import {Serialisable} from "../serialisable";

export class SecurityGateAlarmDto extends Serialisable {
    id: number;
    securityGateId: number;
    dateTimeUtc: string;
    securityGateName: string;
    assetNumber: string;
    title: string;
    falseAlarm: boolean | null;

    isNewAlarm: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/security-gate-alarm.dto.ts